import { createContext, useContext } from 'react';

export const DockExpansionContext = createContext({
    setDockExpanded: () => {},
});

export const useDockExpansion = () => useContext(DockExpansionContext);
